import "antd/lib/dropdown/style";
import _Dropdown from "antd/lib/dropdown";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/avatar/style";
import _Avatar from "antd/lib/avatar";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import React, { useEffect } from 'react';
import Link from 'next/link';
import { Auth } from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';
import endUserMessages from 'utils/endUserMessages';
import { resetTrackingId } from 'utils/tracking';
import handleError from 'utils/http/handleError';
import { loadUser } from 'redux/actions/user';
import { useDispatch, useSelector } from 'react-redux';
import signIn from 'utils/signIn';
import { brandColors } from 'const';
var UserButton = function UserButton() {
  var dispatch = useDispatch();
  var user = useSelector(function (state) {
    return state.user.current;
  });
  useEffect(function () {
    Hub.listen('auth', function (_ref) {
      var event = _ref.payload.event;
      switch (event) {
        case 'signIn':
        case 'cognitoHostedUI':
          dispatch(loadUser());
          break;
        case 'signOut':
          resetTrackingId();
          break;
        case 'signIn_failure':
        case 'cognitoHostedUI_failure':
          handleError('error', endUserMessages.ERROR_SIGN_IN);
          break;
        default:
          break;
      }
    });
  }, []);
  var menuItems = [{
    type: 'group',
    label: "Signed in as ".concat(user === null || user === void 0 ? void 0 : user.attributes.name),
    key: 'singed-in-username',
    title: ''
  }, {
    disabled: true,
    label: __jsx("div", null, "Your profile"),
    key: 'user-profile',
    title: ''
  }, {
    label: __jsx(Link, {
      href: "/settings/profile"
    }, "Settings"),
    key: 'user-settings',
    title: ''
  }, {
    type: 'divider',
    title: ''
  }, {
    label: __jsx("div", null, "Sign out"),
    title: '',
    key: 'user-signout',
    onClick: function () {
      var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Auth.signOut();
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }];
  return user ? __jsx(_Dropdown, {
    menu: {
      items: menuItems
    },
    inlineIndent: "36",
    trigger: ['click'],
    placement: "topRight",
    inlineCollapsed: "false",
    mode: "vertical",
    style: {
      minWidth: '200px'
    }
  }, __jsx(_Button, {
    "aria-label": "User settings",
    type: "text",
    style: {
      border: 'none',
      padding: 0,
      margin: 0
    },
    icon: __jsx(_Avatar, {
      style: {
        backgroundColor: brandColors.DARK_LILAC,
        verticalAlign: 'middle'
      },
      size: "medium"
    }, user.attributes.name[0].toUpperCase())
  })) : __jsx(_Button, {
    type: "dashed",
    onClick: function onClick() {
      return signIn();
    }
  }, "Sign in");
};
UserButton.defaultProps = {};
export default UserButton;